export default __webpack_public_path__ + "static/media/rules-modal.25fb1a85.png";